import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/base.scss';
import App from './App';
import reportWebVitals from './system/reportWebVitals';
import { Provider } from 'react-redux';
import configureStore from './redux/configureStore';

const store = configureStore();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<Provider store={store}>
		{/*<React.StrictMode>*/}
		<App />
		{/*</React.StrictMode>*/}
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
